import { useData } from '../../contexts/DataContext'
import { useFilters } from '../../contexts/FilterContext'
import FilterGroup from './FilterGroup'

function FilterPanel() {
  const { attributes } = useData()
  const { activeCategory, filterCount, clearFilters, hasActiveFilters } =
    useFilters()

  const currentAttributes = attributes[activeCategory]

  if (!currentAttributes?.groups) {
    return (
      <div className="filter-panel p-6 animate-fade-in">
        <h3 className="font-semibold text-surface-900 mb-3">Filters</h3>
        <div className="flex items-center justify-center py-8">
          <div className="loading-shimmer h-4 w-32 rounded"></div>
        </div>
      </div>
    )
  }

  return (
    <div className="filter-panel p-4 animate-fade-in">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-semibold text-surface-900 text-lg">
          🔍 Filters
          {filterCount > 0 && (
            <span className="ml-3 px-3 py-1 bg-gradient-to-r from-primary-500 to-primary-600 text-white text-xs rounded-full font-semibold shadow-sm">
              {filterCount}
            </span>
          )}
        </h3>

        {hasActiveFilters() && (
          <button
            onClick={clearFilters}
            className="text-xs text-primary-600 hover:text-primary-700 font-medium transition-colors hover:underline"
          >
            Clear All
          </button>
        )}
      </div>

      <div className="space-y-4">
        {currentAttributes.groups.map(group => (
          <FilterGroup key={group.id} group={group} />
        ))}
      </div>

      {/* Filter Summary */}
      {hasActiveFilters() && (
        <div className="mt-4 pt-4 border-t border-surface-200 bg-gradient-to-r from-primary-50/50 to-blue-50/50 rounded-lg p-3">
          <h5 className="text-xs font-semibold text-surface-700 mb-2 flex items-center">
            <span className="w-2 h-2 bg-primary-500 rounded-full mr-2"></span>
            Active Filters:
          </h5>
          <div className="text-xs text-surface-600 font-medium">
            {filterCount} filter{filterCount !== 1 ? 's' : ''} applied
          </div>
        </div>
      )}
    </div>
  )
}

export default FilterPanel
